import API from '@/org-app/api';
import {
  GET_ALL_LIFESIGHT_AUDIENCE_SEGMENTS,
  GET_LIFESIGHT_AUDIENCE_SEGMENTS,
  GET_LIFESIGHT_COUNTRIES_AND_CATEGORIES,
} from '@/org-app/store/modules/lifesightAudienceSegments/mutation-types';
import { createApiAction, createGetAllAction } from '@/utils/ActionsUtils';

export default {
  getLifesightAudienceSegmentsByOrg: createGetAllAction(
    API.instance.getExternalAudienceSegmentsByOrg,
    GET_LIFESIGHT_AUDIENCE_SEGMENTS,
    'messages.failedToGetAudienceFile',
  ),
  getLifesightCountriesAndCategoriesByOrg: createApiAction(
    API.instance.getExternalCountriesAndCategoriesByOrg,
    GET_LIFESIGHT_COUNTRIES_AND_CATEGORIES,
    'messages.failedToGetAudienceFile',
  ),
  getAllLifesightSegments: createGetAllAction(
    API.instance.getAllExternalSegmentsForDataProvider,
    GET_ALL_LIFESIGHT_AUDIENCE_SEGMENTS,
    'messages.failedToGetAudienceFile',
  ),
};
